import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

var PushNotificationPreviewer = function PushNotificationPreviewer(props) {
  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(ColLeft, null, /*#__PURE__*/React.createElement("div", {
    className: "d-flex mb-4"
  }, /*#__PURE__*/React.createElement(Logo, null, props.logo), /*#__PURE__*/React.createElement("div", {
    className: "sub"
  }, props.title1)), /*#__PURE__*/React.createElement("div", {
    className: "mb-2"
  }, /*#__PURE__*/React.createElement("b", null, props.title2)), /*#__PURE__*/React.createElement("div", null, props.description)), /*#__PURE__*/React.createElement(ColRight, null, /*#__PURE__*/React.createElement("div", {
    className: "sub mb-4"
  }, props.time), props.image && /*#__PURE__*/React.createElement(Image, {
    src: props.image,
    alt: props.title1 ? props.title1 : 'Image Alt'
  })));
};

PushNotificationPreviewer.propTypes = {
  className: PropTypes.string,
  title1: PropTypes.string,
  title2: PropTypes.string,
  logo: PropTypes.element,
  description: PropTypes.string,
  image: PropTypes.string,
  time: PropTypes.string
};
var Container = styled.div.withConfig({
  displayName: "PushNotificationPreviewer__Container",
  componentId: "sc-12ltvhg-0"
})(["border-radius:10px;display:flex;flex-direction:row;justify-content:space-between;font-size:15px;line-height:18px;padding:8px;.sub{font-size:13px;color:#999999;white-space:nowrap;}"]);
var ColLeft = styled.div.withConfig({
  displayName: "PushNotificationPreviewer__ColLeft",
  componentId: "sc-12ltvhg-1"
})(["margin-right:4px;"]);
var ColRight = styled.div.withConfig({
  displayName: "PushNotificationPreviewer__ColRight",
  componentId: "sc-12ltvhg-2"
})(["width:56px;"]);
var Logo = styled.div.withConfig({
  displayName: "PushNotificationPreviewer__Logo",
  componentId: "sc-12ltvhg-3"
})(["width:20px;height:20px;margin-right:7px;background-color:#444749;"]);
var Image = styled.img.withConfig({
  displayName: "PushNotificationPreviewer__Image",
  componentId: "sc-12ltvhg-4"
})(["width:38px;height:38px;object-fit:cover;"]);
export default PushNotificationPreviewer;